// @ts-nocheck
import React, { Component } from "react"

import DataCard1xN from "./DataBlock1xN"
import DataCard2xN from "./DataBlock2xN"

import HOOK from "../hooks"
import { firstCharacterToUpperCase, getCheckboxName } from "../../modules/utilities"
import { BLOCK, COLOR, COUNTRY, KIND, JARGON, LAYOUT, TENSE, TENSE_ENUM, TOOLTIP } from "../../modules/constants"
import { CHECKBOX } from "../../modules/checkbox_constants"

import NumerableIconButton from "../NumerableIconButton"
import cheatSheetPdf from '../CheatSheetPdf_Company'

import MuiDivider from '@mui/material/Divider'
import SystemUpdateAltOutlinedIcon from "@mui/icons-material/SystemUpdateAltOutlined"
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined"
import Box from "@mui/material/Box"

import AnnualReportMenu from "./CompanyDataMenus/AnnualReportMenu"
import CompaniesHouseMenu from "./CompanyDataMenus/CompaniesHouseMenu"
import WebsiteMenu from "./CompanyDataMenus/WebsiteMenu"
import AccountsMenu from "./CompanyDataMenus/AccountsMenu"
import MapMenu from "./CompanyDataMenus/MapMenu"

// Plain MUI Divider spans the full column width, but the column's left padding already
// insets its left end - so the right end also needs an explicit inset to match.
const Divider = () => <MuiDivider style={{ marginRight: LAYOUT.COLUMN_PADDING }} />

class CompanyData extends Component {

  render() {
    // console.log('CompanyData this.props:', this.props)
    const { cheatSheet, csvEnabled, externalLinks, features, getStatusLevel, handleCsvButtonClick, hubData, kind, nodes, portrait, showLseDataCard, the350club, urlTrialDaysLeft } = this.props

    const dataItems = {}

    dataItems.core = [
      { id: `${JARGON.INCORPORATED} in`, value: hubData.companyRegCountry, type: "icon" },
      { id: "company no.", value: hubData.companyNumber },
      { id: "status", value: firstCharacterToUpperCase(hubData.status), color: COLOR[getStatusLevel(hubData.status)] },
    ]

    dataItems.core.push({ id: "founded", value: hubData.fromDate === "Jan 1970" ? "unknown" : hubData.fromDate })

    if (hubData.toDate)
      dataItems.core.push({ id: "ceased", value: hubData.toDate, color: COLOR[getStatusLevel(hubData.status)] })

    dataItems.details = hubData.companyRegCountry === "GB"
      ? [
        { id: "company type", value: hubData.companyType },
        { id: "address", value: hubData.fullAddress },
        { id: "activities", value: hubData.activities },
      ]
      : [ // not a GB company
        { id: `${JARGON.INCORPORATED} in`, value: COUNTRY[hubData.companyRegCountry].name }
      ]

    if (hubData.previousNames)
      dataItems.details.push({ id: "previous names", value: hubData.previousNames.toUpperCase() })

    const { lseProps } = hubData

    dataItems.lse = [
      { id: JARGON.EPIC.toLowerCase(), value: hubData.lseProps?.epics[0] ?? "?" },
      {
        id: JARGON.LSE_GROUP, value: hubData.lseProps
          ? getCheckboxName(CHECKBOX[HOOK.LSE_INDEX], hubData.lseProps.indexBit)
          : "?"
      },
      {
        id: JARGON.LSE_COMPANY_TYPE,
        value: lseProps
          ? `${lseProps.aic ? JARGON.COMPANY_TYPE.INVEST : JARGON.COMPANY_TYPE.TRADE} company`
          : "?",
        tooltip: "",
      },
      {
        id: JARGON.ICB_INDUSTRY,
        value: lseProps
          ? `${getCheckboxName(CHECKBOX[HOOK.INDUSTRY], lseProps.industryBit)}`
          : "?",
        tooltip: "",
      },
    ]

    // We don't show these values on CompanyData board but require them (formatted) for pdf snapshot
    dataItems.fiscal = [
      {
        id: "market cap.", value: hubData.lseProps && hubData.lseProps.marketCap
          ? `£${hubData.lseProps.marketCap.toLocaleString()}M`
          : "?"
      },
      {
        id: "revenue", value: hubData.lseProps && hubData.lseProps.revenue
          ? `£${hubData.lseProps.revenue.toLocaleString()}M`
          : "?"
      },
    ]

    const connections = hubData?.connectionCounts?.connections

    const officerCounts = lseProps
      ? [
        { id: `${TENSE[TENSE_ENUM.CURRENT].NAME.toLowerCase()} officers`, value: connections.officer.current },
        { id: `${TENSE[TENSE_ENUM.PAST].NAME.toLowerCase()} officers`, value: connections.officer.past },
        { id: `${TENSE[TENSE_ENUM.FUTURE].NAME.toLowerCase()} officers`, value: connections.officer.future },
        { id: `${JARGON.ENDING.toLowerCase()} officers`, value: connections.officer.notice },
      ]
      : [
        { id: `${TENSE[TENSE_ENUM.CURRENT].NAME.toLowerCase()} officers`, value: connections.officer.current },
        { id: `${TENSE[TENSE_ENUM.PAST].NAME.toLowerCase()} officers`, value: connections.officer.past },
        { id: `${TENSE[TENSE_ENUM.CURRENT].NAME.toLowerCase()} PSCs`, value: connections.psc.current },
        { id: `${TENSE[TENSE_ENUM.PAST].NAME.toLowerCase()} PSCs`, value: connections.psc.past },
      ]

    // console.log('hubData.lseProps?.websiteLinks:', hubData.lseProps?.websiteLinks)
    var tipEnabled = TOOLTIP.exportAsCSV
    var tipDisabled = nodes.length <= 1
      ? ""
      : !csvEnabled && features?.Trial
        ? JARGON.NOT_INCLUDED_IN_TRIAL
        : JARGON.SUBSCRIBED_USERS_ONLY

    const csvButton = {
      disabled: !csvEnabled || nodes.length < 2, // 1st node is the company
      tipEnabled,
      tipDisabled: tipEnabled + tipDisabled,
      icon: <SystemUpdateAltOutlinedIcon />,
      label: "Export as CSV",
      handleClick: () => { handleCsvButtonClick() },
      fontWeight: "normal",
    }

    tipEnabled = "generate a PDF snapshot of this company"
    const pdfButton = {
      disabled: !cheatSheet || nodes.length < 2,
      tipEnabled,
      tipDisabled: tipEnabled + tipDisabled,
      icon: <DescriptionOutlinedIcon />,
      label: `${JARGON.CHEAT_SHEET} PDF`,
      handleClick: () => { cheatSheetPdf(pdfProps) },
      fontWeight: "normal",
    }

    const enableAnnualReportMenu = this.props.features.MaxLseData ||
      the350club || (urlTrialDaysLeft > 0)

    const pdfProps = {
      ...this.props,
      dataItems,
      cheatSheet,
      committees: this.props.kind === KIND.NEXUS.COMPANY.COMMITTEES,
    }

    // If lse company, only show the core info and links (snapshot, annual report etc)
    // Otherwise, show the core, detals and officer counts
    return (
      <React.Fragment>
        <
          // @ts-ignore
          DataCard2xN dataItems={dataItems.core} valueFontSize={BLOCK.FONT_SIZE} />
        <Divider />

        {showLseDataCard && <React.Fragment>
          <
            // @ts-ignore
            DataCard2xN dataItems={dataItems.lse} valueFontSize={BLOCK.FONT_SIZE} />
          <Divider />
        </React.Fragment>}

        {!showLseDataCard && <React.Fragment>
          <
            // @ts-ignore
            DataCard1xN dataItems={dataItems.details} valueFontSize={BLOCK.FONT_SIZE} />
          <Divider />
        </React.Fragment>}

        {<React.Fragment>
          <
            // @ts-ignore
            DataCard2xN dataItems={officerCounts} valueFontSize={BLOCK.FONT_SIZE} />
          <Divider />
        </React.Fragment>}

        <
          // @ts-ignore
          Box style={{ height: 10 }} />

        {(kind === KIND.NEXUS.COMPANY.BOARD || kind === KIND.NEXUS.COMPANY.COMMITTEES || kind === KIND.NEXUS.COMPANY.CONNECTIONS) &&
          <React.Fragment>
            <
              // @ts-ignore
              NumerableIconButton item={pdfButton} portrait={portrait} />
            <
              // @ts-ignore
              NumerableIconButton item={csvButton} portrait={portrait} />
            <Divider />
          </ React.Fragment>
        }


        {/* website */}
        <WebsiteMenu
          externalLinks={externalLinks}
          hubData={hubData}
          enableWebsite={showLseDataCard}
          portrait={portrait}
        />
        <Divider />

        {/* accounts or annual report */}
        {
          enableAnnualReportMenu && hubData.lseProps?.annualReport &&
          <AnnualReportMenu externalLinks={externalLinks} hubData={hubData} enablePages={true} portrait={portrait} />
        }

        {
          (!enableAnnualReportMenu || !hubData.lseProps?.annualReport) &&
          <AccountsMenu externalLinks={externalLinks} hubData={hubData} portrait={portrait} />
        }
        <Divider />

        {/* companies house */}
        {
          hubData.companyRegCountry === "GB" && hubData.companyNumber &&
          <CompaniesHouseMenu companyNumber={hubData.companyNumber} externalLinks={externalLinks} portrait={portrait} />
        }
        <Divider />

        {/* Map */}
        {
          hubData.mapLink && <MapMenu externalLinks={externalLinks} hubData={hubData} portrait={portrait} />
        }

      </React.Fragment >
    )
  }
}

export default CompanyData